module.exports = __webpack_public_path__ + "media/pricing/Safety-a229c2ee.svg";